import loaderSlice from './slice';

export { default as initialState } from './state';

export type { ILoaderState } from './state';

export const { resetAllLoaders, setIsFetchingData } = loaderSlice.actions;

export default loaderSlice.reducer;
